var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',[(_vm.gpsParam)?_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$t('public.gps_switch')}},[_vm._v(" "+_vm._s(_vm.gpsParam.gps_switch ? _vm.$t('public.open') : _vm.$t('public.close'))+" ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }